<template>
  <div id="app"  class="primary-bg">
    <header-bar/>
    <router-view/>
  </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue'
export default {
  name: 'App',
  components: {
    HeaderBar,
  }
}
</script>


<style lang="scss">
@import '@/assets/shared.scss';
html, body {
  margin: 0;
}
html {
  height: 100vh;
  max-height: 100vh;
  width: 100vw;
  max-width: 100vw;
}
body {
  height: 100%;
  background-image: url('assets/greenBackground.jpg');
  background-size: cover;
  background-attachment: fixed;
  font-size: 100%;
  line-height: 1.5em;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  height: 100%;
  max-width: 800px;
  margin:auto;
  font-family: 'PT Sans', sans-serif;
}
</style>
